//...
import * as Sentry from "@sentry/react";

export const initSentry = () => {
  return Sentry.init({
    release: process.env.REACT_APP_UI_VERSION,
    dsn: process.env.REACT_APP_SENTRY,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),
      Sentry.browserProfilingIntegration(),
    ],
    enableLogs: true,
    // Performance Monitoring
    tracesSampleRate: 0.25, //  Capture 25% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/app\.atiraspace\.com/,
      /^https:\/\/atiraspace\.com/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.25, // This sets the sample rate at 25%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    profileSessionSampleRate: 0.5,
    environment: process.env.REACT_APP_ENV,
    debug: process.env.REACT_APP_ENV === "development",
    tunnel: `${process.env.REACT_APP_API_URL}/sentry/tunnel`,
    sampleRate: 1.0,
  });
};
